import axios, { serviceFailureHandle, serviceSuccessHandle } from './AxiosConfig'

export const getBookingDetail = (pageDetail?: object) => {
  return axios.post('/api/booking/list', pageDetail).then(serviceSuccessHandle).catch(serviceFailureHandle)
}
export const getBookingDetails = (bookingId : string) => {
  return axios.get('/api/booking/details/' + bookingId).then(serviceSuccessHandle).catch(serviceFailureHandle)
}
